function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.darkblue{fill:#24365C;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "darkblue",
  d: "M464,2H48C21.5,2,0,23.5,0,50v288c0,26.5,21.5,48,48,48h356c-7-141,108-121.5,108-148V50 C512,23.5,490.5,2,464,2z M48,34h416c8.8,0,16,7.2,16,16v41.4c-21.9,18.5-53.2,44-150.6,121.3c-16.9,13.4-50.2,45.7-73.4,45.3 c-23.2,0.4-56.6-31.9-73.4-45.3C85.2,135.4,53.9,109.9,32,91.4V50C32,41.2,39.2,34,48,34z M404,354H48c-8.8,0-16-7.2-16-16V133 c22.8,18.7,58.8,47.6,130.7,104.7c20.5,16.4,56.7,52.5,93.3,52.3c36.4,0.3,72.3-35.5,93.3-52.3c71.9-57.1,107.9-86,130.7-104.7v105 C480,246.8,407,269,404,354z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "darkblue",
  d: "M650.1,392.3l-28.8-16.6c2.9-15.7,2.9-31.7,0-47.4l28.8-16.6c3.3-1.9,4.8-5.8,3.7-9.4 c-7.5-24-20.2-45.8-36.9-63.8c-2.6-2.8-6.7-3.4-10-1.6l-28.8,16.6c-12.1-10.4-26-18.4-41-23.7v-33.1c0-3.8-2.6-7.1-6.3-7.9 c-24.8-5.5-50.1-5.3-73.7,0c-3.7,0.8-6.3,4.1-6.3,7.9v33.2c-15,5.3-28.9,13.4-41,23.7L381,236.9c-3.3-1.9-7.4-1.3-10,1.6 c-16.7,18-29.4,39.8-36.9,63.8c-1.1,3.6,0.4,7.6,3.7,9.4l28.8,16.6c-2.9,15.7-2.9,31.7,0,47.4l-28.8,16.6c-3.3,1.9-4.8,5.8-3.7,9.4 c7.5,24,20.2,45.8,36.9,63.8c2.6,2.8,6.7,3.4,10,1.6l28.8-16.6c12.1,10.4,26,18.4,41,23.7v33.2c0,3.8,2.6,7.1,6.3,7.9 c24.8,5.5,50.1,5.3,73.7,0c3.7-0.8,6.3-4.1,6.3-7.9v-33.2c15-5.3,28.9-13.4,41-23.7l28.8,16.6c3.3,1.9,7.4,1.3,10-1.6 c16.7-18,29.4-39.8,36.9-63.8C654.9,398.1,653.4,394.2,650.1,392.3z M493.9,406c-29.8,0-54-24.2-54-54c0-29.8,24.2-54,54-54 c29.8,0,54,24.2,54,54C547.9,381.8,523.7,406,493.9,406z"
});

const SvgEmailSettings = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 657.4 519.4",
    style: {
      enableBackground: "new 0 0 657.4 519.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmailSettings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email-settings.657b1a79.svg";
export { ForwardRef as ReactComponent };